import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { GoogleOAuthProvider } from '@react-oauth/google'

import reducers from './reducers'

import App from './App'
import './index.css'

const store = createStore(reducers, compose(applyMiddleware(thunk)))

ReactDOM.render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={'801136565815-l5ghm8rmgo85aenrq02ppkf5n5vhobgk.apps.googleusercontent.com'}>
      <App />
    </GoogleOAuthProvider>
  </Provider>,
  document.getElementById('root')
)
